module.exports = __webpack_public_path__ + "static/img/logo03.0d51e0b.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/image/home/logo/logo03.jpg
// module id = znbW
// module chunks = 1